<template>
<div class="chapter">
<div class="inner_page">
<p class="copyt"><b><span class="small">PUBLISHER:</span></b> Amy Marson</p>
<p class="copy"><b><span class="small">CREATIVE DIRECTOR:</span></b> Gailen Runge</p>
<p class="copy"><b><span class="small">EDITOR:</span></b> Lynn Koolish</p>
<p class="copy"><b><span class="small">TECHNICAL EDITOR:</span></b> Linda Johnson</p>
<p class="copy"><b><span class="small">COVER/BOOK DESIGNER:</span></b> Kerry Graham</p>
<p class="copy"><b><span class="small">PRODUCTION COORDINATOR:</span></b> Joe Edge</p>
<p class="copy"><b><span class="small">PRODUCTION EDITORS:</span></b> Jeanie German and Alice Mace Nakanishi</p>
<p class="copy"><b><span class="small">ILLUSTRATORS:</span></b> Becky Goldsmith and Linda Johnson</p>
<p class="copy"><b><span class="small">PHOTO ASSISTANT:</span></b> Mai Yong Vang</p>
<p class="copy"><b><span class="small">HAND MODEL:</span></b> Kristi Visser</p>
<p class="copy"><b>Photography by Diane Pedersen of C&amp;T Publishing, Inc., unless otherwise noted</b></p>
<p class="copy"><b>Published by C&amp;T Publishing, Inc.,<br/>P.O. Box 1456, Lafayette, CA 94549</b></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_copyrighttitle.vue?27b29e51